// extracted by mini-css-extract-plugin
module.exports = {"bar":"_5DZcaB0Z","icon":"_5DQcSLzI","info-container":"_5D1LMeBr","modal":"_5D4F-xP4"};